import restClient from "../restClient";

const endpoint = "/channels";

export const getChannels = async (type, page, pageSize, search, status = ["active"]) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const params = { page, pageSize };
    if (type && type.length > 0) {
      // If type is an array, send as array; if string, send as string
      params.type = Array.isArray(type) ? type : type.toLowerCase().replace(/\s+/g, '-');
    }
    if (search) {
      params.search = search.toLowerCase().replace(/\s+/g, '-');
    }
    if (status) {
      params.status = Array.isArray(status) ? status : [status];
    }
    const response = await restClient.get(endpoint, { ...config, params });
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getChannel = async (id, tab) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`${endpoint}/${id}?type=${tab.toLowerCase().replace(/\s+/g, '-')}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const createChannel = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(endpoint, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};


export const createSalesDocument = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post("/sales-documents", { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const updateSalesDocument = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`/sales-documents/${id}`, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateChannel = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`${endpoint}/${id}`, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const deleteChannel = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`${endpoint}/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}; 